<template>
  <div
    ref="overlayContent"
    class="document-similar-documents d-flex flex-column i-p-10 i-pb-10 i-gap-10"
    data-testid="similar-documents-overlay"
  >
    <div class="text d-flex flex-column align-items-start i-gap-1">
      <div class="name i-text-heading-6 i-text-neutral-120">
        Similar Documents
      </div>
      <div class="subtitle i-text-body-3 i-text-neutral-110">
        How does this document compare?
      </div>
    </div>

    <!-- document trust score chart -->
    <document-trust-score-chart
      v-if="showTrustScore && !this.loadingTrustScoreDistribution"
      :customer-id="customerId"
      :document="document"
    ></document-trust-score-chart>

    <!-- Similar Documents -->
    <div class="similar-docs-container data-box d-flex flex-column">
      <similar-documents-list :customer-id="customerId" :document="document" />
    </div>
  </div>
</template>

<script>
import DocumentTrustScoreChart from '@/V2/documents/document-view/DocumentTrustScoreChart';
import SimilarDocumentsList from '@/V2/documents/SimilarDocumentsList';
import { TrustScoreDistributionDataSets } from '@/V2/stores/SimilarDocumentsStore';
import { mapActions } from 'vuex';
export default {
  components: { DocumentTrustScoreChart, SimilarDocumentsList },

  props: {
    document: {
      type: Object,
      default: undefined,
    },
    customerId: {
      type: String,
      default: undefined,
    },
    showTrustScore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loadingTrustScoreDistribution: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadDistributionData();
    });
  },

  methods: {
    ...mapActions({
      loadScoreDistribution: 'loadScoreDistribution',
    }),
    loadDistributionData() {
      this.loadingTrustScoreDistribution = true;
      // load Data
      const calls = [
        TrustScoreDistributionDataSets.WORKSPACE,
        TrustScoreDistributionDataSets.INSCRIBE,
      ].map(
        (type) =>
          new Promise((resolve, reject) => {
            this.loadScoreDistribution({
              documentId: this.document.id,
              customerId: this.customerId,
              type: type,
            }).then(resolve);
          }),
      );

      Promise.all(calls).then(() => {
        this.loadingTrustScoreDistribution = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.document-similar-documents {
  width: 100%;
}
</style>
